import React from 'react';
import { useHistory } from 'react-router-dom';
import { FinalButton } from '../FinalButton';
import { Grid } from '../Grid';
import { Icon } from '../Icons';
import { McpOnly, PermsOnly, useCurrentProvider } from '../Permissions';
import { supportLinkAnchorProps, useSupportLink } from '../SupportLink';
import { NavLink, UserFooter } from './Styles';

type NavFooterProps = {
  organizationId?: number;
};

export const NavFooter = ({ organizationId }: NavFooterProps) => {
  const history = useHistory();
  const { currentProvider, logout } = useCurrentProvider();
  const supportLink = useSupportLink();

  return (
    <div>
      <McpOnly>
        <PermsOnly allowed="patientCreate">
          <div className="flex ph3 pv3 o-80">
            <FinalButton
              className="flex-auto"
              iconLeft="iconsWhitePlusSvg"
              kind="outline_white"
              pill
              onClick={() => history.push(`/organizations/${organizationId}/students/enroll`)}
            >
              Add Student
            </FinalButton>
          </div>
        </PermsOnly>
      </McpOnly>
      <NavLink as="a" {...supportLinkAnchorProps(supportLink)}>
        <Grid gridTemplateColumns="2.25rem 1fr" alignItems="center">
          <Icon icon="iconsQuestionSvg" size={20} />
          <p className="o-50 f6">Need Help?</p>
        </Grid>
      </NavLink>
      <UserFooter>
        <Grid gridTemplateColumns="2.25rem 1fr" className="ml2">
          <Icon size={20} style={{ filter: 'invert(100%)' }} icon="iconsUserSvg" />
          <div>
            <p className="f6 b mb2">{currentProvider.name}</p>
            <button
              type="button"
              className="f6 link white o-50 bg-inherit bw0 pointer pa0"
              onClick={logout}
            >
              Log Out
            </button>
          </div>
        </Grid>
      </UserFooter>
    </div>
  );
};
